import {DecisionQuestionRow} from "common/flowmaster/types/task_config";

const NAME_PATTERN = /^[A-Za-z0-9_]+$/;

export default function validateDecisionQuestions(
  rows: DecisionQuestionRow[],
): string[] {
  const errors: string[] = [];
  const names = new Set<string>();
  rows.forEach((row, index) => {
    const label = row.name?.trim() || `Check ${index + 1}`;
    if (!NAME_PATTERN.test(row.name ?? "")) {
      errors.push(`${label}: the name may only use letters, digits and _`);
    } else if (names.has(row.name)) {
      errors.push(`${label}: the name is used twice`);
    }
    names.add(row.name);
    if (!row.question?.trim()) {
      errors.push(`${label}: the question is empty`);
    }
    const options = (row.options ?? []).filter(option => option.label?.trim());
    if (row.type !== "predicate" && options.length < 2) {
      errors.push(`${label}: Choice and Score need at least 2 options`);
    }
  });
  if (rows.length > 0 && !rows.some(row => row.enabled !== false)) {
    errors.push("All checks are switched off");
  }
  return errors;
}
